








































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import Vuelidate from 'vuelidate';
import { required, integer, requiredIf, minLength, between } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import vSelect from 'vue-select';

import {
	ProductsApi,
	Product,
	JobsApi,
	Job,
	TransceiversApi,
	SensorsApi,
	VatsApi,
	Vat,
	VatLabelsVats,
	EntityStatus,
} from '@/api';
import EmptyDistanceGenerator from '@/components/empty-distance-generator.vue';
import Toast from '@/components/display/toast.vue';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';

@Component({
	components: {
		SaveCancelButtons,
		secondaryNav,
		Toast,
	},
	validations: {},
	mixins: [validationMixin],
})
export default class VatUpdate extends Vue {
	public loading = false;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public product: Product | null = null;
	public vats: Vat[] = [];
	public vatsOriginal: number[] = [];
	public componentKey = 0;
	private api: ProductsApi = new ProductsApi();
	constructor() {
		super();
	}

	public get vatOptions(): { value: number; text: string }[] {
		return this.vats.map((vat: Vat) => ({
			value: vat.vatNumber ?? 0,
			text: `Vat ${vat.vatNumber}`,
		}));
	}

	public swap(currentVat: Vat, newVatNumber: number) {
		this.vats.filter(vat => vat.vatNumber === newVatNumber)[0].vatNumber = currentVat.vatNumber;
		currentVat.vatNumber = newVatNumber;
	}

	public async onSubmit() {
		this.submitStatus = 'PENDING';
		if (this.vatsOriginal.toString() !== this.vats.map(vat => vat.vatNumber).toString()) {
			if (
				!confirm(
					'WARNING You are about to change the current vatsetup from: ' +
						this.vatsOriginal.map(vatNumber => '\n' + `Vat ${vatNumber}`) +
						'\n to: ' +
						this.vats.map(vat => '\n' + `Vat ${vat.vatNumber}`),
				)
			) {
				this.submitStatus = 'OK';
				return;
			} else {
				const { productId } = this.$route.params;
				const vats = this.vats.map<VatLabelsVats>(vat => ({
					vatId: vat.id,
					vatNumber: vat.vatNumber ?? undefined, // Swagger only accepts number | undefined
				}));
				try {
					await new ProductsApi().productVatLabels(parseInt(productId, 10), { data: { vats } });
				} catch (e) {
					const error = e.response;
					new Toast().makeToast(error, 'Error changing vats', 'danger', true);
					this.submitStatus = 'ERROR';
					return;
				}
				new Toast().makeToast('vats changed', 'succesfully changed vats', 'success', true);
				setTimeout(() => {
					this.$router.push({ name: 'products.milk.view', params: { productId: this.product.id } });
				}, 1000);
			}
		} else {
			this.$router.push({ name: 'products.milk.view', params: this.$route.params });
		}
	}

	public async load() {
		const { productId } = this.$route.params;
		this.loading = true;
		try {
			const { data } = await this.api.getProductById(parseInt(productId, 10), {
				params: {
					include: 'vats,org',
				},
			});
			this.product = data;
			this.vats = (data.vats || Array.of<Vat>()).filter(
				(vat: Vat) => vat.status !== EntityStatus.Removed && vat.status !== EntityStatus.Cancelled,
			);
			this.vatsOriginal = this.vats.map(vat => vat.vatNumber) || [];
		} catch (e) {
			console.log(e);
			this.product = null;
		} finally {
			this.loading = false;
		}
	}

	public created() {
		this.load();
	}
}
